export type PresenceFilter = 'with' | 'without';

export type ReviewSearchParams = {
    reviewText?: string;
    answerText?: string;
    hasPhotos?: PresenceFilter;
    hasAuthor?: PresenceFilter;
    hasReviewText?: PresenceFilter;
    hasAnswerText?: PresenceFilter;
    hasAiResponse?: PresenceFilter;
    rating?: string;
    createdDate?: string;
    answerUpdatedDate?: string;
    convertedStatus?: string;
    platform?: string;
    productId?: string;
    brandName?: string;
};

export type ReviewSearchParamsDto = ReviewSearchParams;

export const REVIEW_SEARCH_PARAM_KEYS = [
    'reviewText',
    'answerText',
    'hasPhotos',
    'hasAuthor',
    'hasReviewText',
    'hasAnswerText',
    'hasAiResponse',
    'rating',
    'createdDate',
    'answerUpdatedDate',
    'convertedStatus',
    'platform',
    'productId',
    'brandName',
] as const satisfies Array<keyof ReviewSearchParams>;

export const ANSWER_KIND_VALUES = ['human', 'template', 'ai_unchanged', 'ai_changed'] as const;

export type AnswerKind = (typeof ANSWER_KIND_VALUES)[number];

export type ReviewFeedItemAnswer = {
    reviewFeedItemId: string;
    text: string;
    answerKind?: AnswerKind;
};

export type ReviewAnswerDto = ReviewFeedItemAnswer;

export const convertReviewSearchToSearchParamsArray = (params: ReviewSearchParams) => {
    return REVIEW_SEARCH_PARAM_KEYS.filter((key) => !!params[key]).map((key) => `${key}:${params[key]}`);
};

export const convertReviewSearchDtoToSearchParamsArray = convertReviewSearchToSearchParamsArray;
